// extracted by mini-css-extract-plugin
export default {"contents":"wE-z","sectionHeading":"xE-z"};